import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { branch, compose, renderNothing } from 'recompose';

import { t } from '../../../../modules/infra/i18n';
import { isBrandViewActive } from '../../../auth/selectors';
import { canUseProductReporting, canUserModifyProducts, canUserViewReports } from '../../../common/helpers/users';
import Icon, { GLYPHS } from '../../../common/icon';
import AddBarberPrefix from '../../../common/RoleAwareLink';
import * as shapes from '../../shapes';

class ReportsHeaderDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: false,
    };
  }

  onClick = () => {
    this.setState({ isOpened: false });
  };

  toggleDropdown = (e) => {
    e.preventDefault();
    this.setState({ isOpened: !this.state.isOpened });
  };

  handleClickOutside = () => {
    if (this.state.isOpened) {
      this.setState({ isOpened: false });
    }
  };

  render() {
    const { canModifyProducts, canViewReports, isBrand, productReportingEnabled } = this.props;

    const canShowReportsItems = productReportingEnabled && canModifyProducts && !isBrand;

    const dropdownClass = classNames('c-header-primary__dropdown js-toggle', {
      'is-active': this.state.isOpened,
    });

    const dropdownListClass = classNames('c-header-primary-menu', {
      'is-active': this.state.isOpened,
    });

    return (
      <div className="c-header-primary__item u-position-relative">
        <button type="button" className={dropdownClass} onClick={this.toggleDropdown}>
          <div className="c-heading c-heading--light u-mr-- u-visible-inline-block-for-medium-and-up">
            {this.props.title || t('products:navigation.reports.title')}
          </div>
          <Icon glyph={GLYPHS.arrowCircle} size="medium" className="c-dropdown-icon" />
        </button>
        <div className={dropdownListClass}>
          <ul className="c-separator-list">
            <li className="c-separator-list__item c-separator-list__item--header">
              <AddBarberPrefix
                to="/reports/sales-by-product"
                onlyActiveOnIndex
                className="c-header-primary-menu__link"
                onClick={this.onClick}
                activeClassName="c-header-primary-menu__link is-active"
                display-if={canViewReports}
              >
                {t('products:navigation.reports.sales_by_product')}
              </AddBarberPrefix>
              <AddBarberPrefix
                display-if={canShowReportsItems}
                to="/products/inventory"
                onlyActiveOnIndex
                className="c-header-primary-menu__link"
                onClick={this.onClick}
                activeClassName="c-header-primary-menu__link is-active"
              >
                {t('products:navigation.reports.inventory_report')}
              </AddBarberPrefix>
              <AddBarberPrefix
                display-if={canShowReportsItems}
                to="/products/shrinkage"
                onlyActiveOnIndex
                className="c-header-primary-menu__link"
                onClick={this.onClick}
                activeClassName="c-header-primary-menu__link is-active"
              >
                {t('products:navigation.reports.shrinkage_report')}
              </AddBarberPrefix>
              <AddBarberPrefix
                display-if={canShowReportsItems}
                to="/products/valuation"
                onlyActiveOnIndex
                className="c-header-primary-menu__link"
                onClick={this.onClick}
                activeClassName="c-header-primary-menu__link is-active"
              >
                {t('products:navigation.reports.valuation_report')}
              </AddBarberPrefix>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
ReportsHeaderDropdown.propTypes = {
  canModifyProducts: PropTypes.bool.isRequired,
  canViewReports: PropTypes.bool.isRequired,
  isBrand: PropTypes.bool.isRequired,
  productReportingEnabled: PropTypes.bool.isRequired,
  title: shapes.title.isRequired,
};

const mapStateToProps = (state) => ({
  canViewReports: canUserViewReports(state.auth.permissions),
  canModifyProducts: canUserModifyProducts(state.auth.permissions),
  isBrand: isBrandViewActive(state),
  title: state.products.reportTitle,
  permissions: state.auth.permissions,
  productReportingEnabled: canUseProductReporting(state),
});

export default compose(
  connect(mapStateToProps),
  withRouter,
  branch((props) => !props.productReportingEnabled && !canUserViewReports(props.permissions), renderNothing),
  onClickOutside
)(ReportsHeaderDropdown);
